import { Directive } from '@angular/core';

@Directive({
    selector: '[ibtnUnboxed]',
    host: { class: 'ibtn-ub' }
})
export class IconButtonUnboxedDirective {
}
